const enUS = {
  'common.appTitle': 'Performance Coach',
  'common.formHasErrors': 'Please check the form for missing required fields',
  'common.from': 'from',
  'common.to': 'to',
  'common.today': 'Today',
  'common.more': 'More',
  'common.editEntity': 'Edit',
  'common.abort': 'Cancel',
  'common.delete': 'Delete',
  'common.language': 'Select',
  'common.defaultMenuTitle': 'Appointments',
  'common.signOut': 'Sign out',
  'common.defaultStoreSettings': 'Store settings',
  'common.save': 'Save',
  'common.confirm': 'Confirm',
  'common.error': 'Error',
  'common.defaultError': 'Something went wrong',
  'common.defaultErrorDescription': 'Clear cache and reload',
  'common.createAppointmentError': 'An error occurred while creating the event',
  'common.createAppointmentErrorDescription': 'The event was not created. Please check your internet connection',
  'common.deleteAppointmentError': 'An error occurred while trying to delete the event',
  'common.deleteAppointmentErrorDescription': 'The event has not been deleted. Please check your internet connection',
  'common.appVersion': 'Version',
  'common.minutesShort': '{minutes} min',
  'common.hour': 'Hour',
  'common.minutes': 'Minutes',
  'common.gender.none': '-',
  'common.gender.male': 'Mr',
  'common.gender.female': 'Ms',
  'common.search': 'Search',
  'common.epepSyncInProcess': 'Import of {source} data started',
  'common.epepSyncDelay': 'Waiting for {source} data: {delay}s',
  'common.pageNotFound': 'Page not found',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.clearFilters': 'Clear filters',
  'menu.operations': 'Operations',
  'menu.performance': 'Performance',
  'menu.appointments': 'Appointments',
  'menu.settings': 'Settings',
  'language.czech': 'Czech',
  'language.english': 'English',
  'language.french': 'French',
  'language.german': 'German',
  'language.italian': 'Italian',
  'language.polish': 'Polish',
  'performanceIndicatorsColumnName.region': 'Region',
  'performanceIndicatorsColumnName.storeid': 'Store ID',
  'performanceIndicatorsColumnName.ltb_status': 'Using LTB',
  'performanceIndicatorsColumnName.store_name': 'Store Name',
  'performanceIndicatorsColumnName.last_week': 'Last week',
  'performanceIndicatorsColumnName.last_week_prev_year': 'Last week previous year',
  'performanceIndicatorsColumnName.problems_count': 'Problems Count',
  'performanceIndicatorsColumnName.capacity_flag': 'Capacity',
  'performanceIndicatorsColumnName.capacity_flag_1': 'Eyetest capacity is missing',
  'performanceIndicatorsColumnName.potential_flag': 'Potential',
  'performanceIndicatorsColumnName.potential_flag_1': 'Low usage of eyetest potential (Work in progress)',
  'performanceIndicatorsColumnName.wait_time_flag': 'Wait Time',
  'performanceIndicatorsColumnName.wait_time_flag_1': 'High wait time',
  'performanceIndicatorsColumnName.productivity_flag': 'Productivity',
  'performanceIndicatorsColumnName.productivity_flag_1': 'Low productivity (Work in progress)',
  'performanceIndicatorsColumnName.service_time_flag': 'Service Time',
  'performanceIndicatorsColumnName.service_time_flag_1': 'They need over 40 mins to service a eyetest and consultation',
  'performanceIndicatorsColumnName.walkin_ratio_flag': 'Waling Ratio',
  'performanceIndicatorsColumnName.walkin_ratio_flag_0': 'Low amount of appointments/high walkins',
  'performanceIndicatorsColumnName.walkin_ratio_flag_1': 'High amount of appointments/low walkins',
  'performanceIndicatorsColumnName.service_split_flag': 'Service Split',
  'performanceIndicatorsColumnName.service_split_flag_1': 'Service split could be beneficial',
  'performanceIndicatorsColumnName.status_50_pct_rule': '50 % Rule',
  'performanceIndicatorsColumnName.conversion_rate_flag': 'Conversion Rate',
  'performanceIndicatorsColumnName.conversion_rate_flag_0': 'Frequency data missing',
  'performanceIndicatorsColumnName.conversion_rate_flag_1': 'Bad conversion rate from frequency to orders',
  'performanceIndicatorsColumnName.cust_interest_freq_flag': 'Customer Interest Frequency',
  'performanceIndicatorsColumnName.cust_interest_freq_flag_0': 'Frequency data is missing',
  'performanceIndicatorsColumnName.cust_interest_freq_flag_1': 'Frequency is down by at least 15%',
  'performanceIndicatorsColumnName.relative_performance_flag': 'Relative Performance',
  'performanceIndicatorsColumnName.relative_performance_flag_-1': '< -10%',
  'performanceIndicatorsColumnName.relative_performance_flag_0': '-10% to 10%',
  'performanceIndicatorsColumnName.relative_performance_flag_1': '> 10%',
  'performanceIndicatorsColumnName.extreme_walkin_changes_flag': 'Extreme Walkin Changes',
  'performanceIndicatorsColumnName.extreme_walkin_changes_flag_1': 'Probably bad DiWa usage previously',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag': 'Customer Serviced Conversion Rate',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag_0': 'No or questionable DiWa Data',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag_1': 'Bad DiWa to orders conversion rate',
  'performanceIndicatorsColumnName.ratio_of_branch_frontend_bookings': 'Ratio of Branch Frontend Bookings',
};

export default enUS;
